export const TRANSLATION_SUPPORTED_LOCALES = ['en', 'es'] as const;

export type TranslationLocale = (typeof TRANSLATION_SUPPORTED_LOCALES)[number];
export type TranslationSourceLocale = TranslationLocale | 'auto';

const APP_LOCALE_STORAGE_KEY = 'jema-manager-locale';

const normalizeBaseLocale = (value?: string | null): string | null => {
  if (!value) return null;
  const normalized = value.trim().toLowerCase();
  if (!normalized) return null;
  const [base] = normalized.split('-');
  return base || null;
};

export const normalizeTranslationLocale = (
  value?: string | null,
  fallback: TranslationLocale = 'en'
): TranslationLocale => {
  const base = normalizeBaseLocale(value);
  if (!base) return fallback;
  return TRANSLATION_SUPPORTED_LOCALES.includes(base as TranslationLocale)
    ? (base as TranslationLocale)
    : fallback;
};

export const normalizeTranslationSourceLocale = (
  value?: string | null
): TranslationSourceLocale => {
  const base = normalizeBaseLocale(value);
  if (!base) return 'auto';
  if (base === 'auto') return 'auto';
  return TRANSLATION_SUPPORTED_LOCALES.includes(base as TranslationLocale)
    ? (base as TranslationLocale)
    : 'auto';
};

export const resolveCurrentTranslationLocale = (): TranslationLocale => {
  if (typeof window !== 'undefined') {
    const stored = window.localStorage.getItem(APP_LOCALE_STORAGE_KEY);
    if (stored) {
      return normalizeTranslationLocale(stored);
    }
  }

  if (typeof navigator !== 'undefined') {
    return normalizeTranslationLocale(navigator.language);
  }

  return 'en';
};

export const shouldSkipTranslation = (
  source: TranslationSourceLocale,
  target: TranslationLocale
): boolean => source !== 'auto' && source === target;
